import React from "react";
import HotlineSvg from "../../asset/icon/Hotline.svg";
// import AppContext from "../../application/AppContext";
import Constants from "../../constant/Constants";

function Hotline({style}) {
    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                color: "#485D69",
                ...style,
            }}
        >
            <HotlineSvg style={{fontSize: 28, marginRight: 12}} />
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginRight: 12,
                }}
            >
                <div style={{fontSize: 12}}>服务热线</div>
                <div style={{fontSize: 13}}>8:00-20:00</div>
            </div>
            <div
                className="number"
                style={{
                    fontSize: 20,
                }}
            >
                {Constants.HOTLINE}
            </div>
        </div>
    );
}

export default Hotline;
